import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { ProblemSection } from '../components/ProblemSection';
import { PainSection } from '../components/PainSection';
import { HopeSection } from '../components/HopeSection';
import { SystemSection } from '../components/SystemSection';
import { SolutionSection } from '../components/SolutionSection';
import { JourneySteps } from '../components/JourneySteps';
import { Features } from '../components/Features';
import { TransformationSection } from '../components/TransformationSection';
import { WhoIsThisFor } from '../components/WhoIsThisFor';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white overflow-x-hidden font-sans" data-id="element-356">
      <main data-id="element-357">
        <Hero data-id="element-358" />
        <PainPoints data-id="element-359" />
        <ProblemSection data-id="element-360" />
        <PainSection data-id="element-361" />
        <HopeSection data-id="element-362" />
        <SystemSection data-id="element-363" />
        <SolutionSection data-id="element-364" />
        <JourneySteps data-id="element-365" />
        <Features data-id="element-366" />
        <TransformationSection data-id="element-367" />
        <WhoIsThisFor data-id="element-368" />
        <PricingSection data-id="element-369" />
        <FinalCTA data-id="element-370" />
      </main>

      <Footer data-id="element-371" />
    </div>;
}